// extracted by mini-css-extract-plugin
export default {"tabContent":"ukcpJNlsjv"};